<template>
  <div class="waw-outcome">
    <div class="waw-outcome__icon">&#x1F4AC;</div>
    <div class="waw-outcome__body">
      <p class="waw-outcome__lead">
        Thanks &mdash; our team has everything they need and is picking this up.
      </p>
      <!-- "we'll let you know", not "we'll email you": no channel is promised anywhere in this
           flow, and naming one commits us to a delivery path nothing in the product guarantees. -->
      <p class="waw-outcome__note">
        You don&rsquo;t need to keep this page open. If anything is needed from you, we&rsquo;ll
        let you know.
      </p>
    </div>
  </div>
</template>

<script>
/**
 * Terminal screen — the wizard has handed this practice to a person.
 *
 * Reached when the setup goes down a branch we do not automate yet: a number that is already live
 * in the WhatsApp app, a local number outside the US, or a country we could not resolve. The
 * handoff already paged our team with every answer the practice gave, so the only job left here is
 * to make the wait feel finished rather than stalled — a practice staring at a screen that looks
 * mid-flow will phone us to ask whether they broke something.
 *
 * "Refresh status" stays available (the frame renders it) because the state does move on our side:
 * once a person finishes the manual part, this screen becomes the next real step.
 */
export default {
  name: 'WizardHandoffPendingStep',
};
</script>

<style lang="scss" scoped>
@import '../../PatientPayments/tokens';

.waw-outcome {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.waw-outcome__icon {
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: $pp-radius-sm;
  background: $pp-brand-subtle;
  font-size: 1.35rem;
  line-height: 1;
}

.waw-outcome__body {
  flex: 1 1 auto;
  min-width: 0;
}

.waw-outcome__lead {
  margin: 0 0 0.6rem;
  color: $pp-text-strong;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.6;
}

.waw-outcome__note {
  margin: 0;
  padding: 0.6rem 0.8rem;
  border-radius: $pp-radius-sm;
  background: $pp-surface-sunken;
  color: $pp-text-muted;
  font-size: 0.83rem;
  line-height: 1.6;
}
</style>
